angular.module('billing').controller('ConfirmPaymentModalCtrl',
    ['$scope', '$uibModalInstance', 'consentAnnual', 'chargeAmount',
        function ($scope, $modalInstance, consentAnnual, chargeAmount) {
            'use strict';

            $scope.consentAnnual = consentAnnual;
            $scope.chargeAmount = chargeAmount;
            function accept() {
                $modalInstance.close('accept');
            }

            function cancel() {
                $modalInstance.dismiss('cancel');
            }

            $scope.accept = accept;
            $scope.cancel = cancel;
        }]);
